import { AutogenModelCarrierPayee, AutogenRowCarrierPayee } from "./autogen/AutogenModelCarrierPayee";

export class ModelCarrierPayee extends AutogenModelCarrierPayee<RowCarrierPayee> {
    constructor() {
        super(RowCarrierPayee);
    }
}

export class RowCarrierPayee extends AutogenRowCarrierPayee {
}